import {Image} from "../types";


export enum ImageCategory {
    COVER = 'COVER',
    BACK_COVER = 'BACK_COVER',
}

export interface ImageTypeMeta {
    value: string;
    category: ImageCategory;
    priority: number;
}

export const IMAGE_TYPES: Record<string, ImageTypeMeta> = {
    RE1: { value: 'RE1', category: ImageCategory.COVER,      priority: 1 },
    TG1: { value: 'TG1', category: ImageCategory.COVER,      priority: 2 },
    GR1: { value: 'GR1', category: ImageCategory.COVER,      priority: 3 },
    VI1: { value: 'VI1', category: ImageCategory.COVER,      priority: 4 },
    RE2: { value: 'RE2', category: ImageCategory.BACK_COVER, priority: 1 },
    TG2: { value: 'TG2', category: ImageCategory.BACK_COVER, priority: 2 },
    GR2: { value: 'GR2', category: ImageCategory.BACK_COVER, priority: 3 },
    VI2: { value: 'VI2', category: ImageCategory.BACK_COVER, priority: 4 },
};

export const selectBestImage = (images: Image[] | undefined, category: ImageCategory): Image | undefined => {
    if (!images?.length) return undefined;
    return images
        .filter(img => IMAGE_TYPES[img.type]?.category === category)
        .sort((a, b) => IMAGE_TYPES[a.type].priority - IMAGE_TYPES[b.type].priority)[0];
};